<template>
  <div>
    <div class="pc-header">
      <div class="content">
        <div class="navigation">
          <div class="logo" @click="goDefaultPage">
            <img src="@/assets/imgs/layout/logo-header.png" alt="">
          </div>
          <router-link class="item" :class="{'active': currentPath === '/manage/affiliate-cid'}" to="/manage/affiliate-cid">{{ $t('common.nav.manage.affiliateCid') }}</router-link>
          <router-link class="item" :class="{'active': currentPath === '/manage/member-reward'}" to="/manage/member-reward">{{ $t('memberReward.memberRewards') }}</router-link>
         <router-link class="item" :class="{'active': currentPath === '/manage/event'}" to="/manage/event">{{ $t('common.nav.manage.event') }}</router-link>
          <router-link class="item" :class="{'active': currentPath === '/manage/notification'}" to="/manage/notification">{{ $t('common.nav.manage.notification') }}</router-link>
          <router-link class="item" :class="{'active': currentPath === '/manage/tool'}" to="/manage/tool">{{ $t('common.nav.manage.managementTool') }}</router-link>
        </div>
        <div class="system-info">
          <div class="item">
            <el-dropdown trigger="click" @command="changeNavLanguage($event, 'manage')">
              <span class="el-dropdown-link">
                {{ currentLanguage }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="header-nav-dropdown">
                <el-dropdown-item
                  v-for="item of navLangList"
                  :key="item.value"
                  :command="item.value"
                  :class="{'active': currentLanguage === item.label}">
                  {{ item.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ manageAccountEmail || '' }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="header-nav-dropdown">
                <el-dropdown-item command="1" v-show="isKKpartners == 1">{{ $t('common.nav.manage.switchToAffiliatePortal') }}</el-dropdown-item>
                <el-dropdown-item command="2">{{ $t('common.nav.logout') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="mweb-header">
      <div class="menu-btn" @click="handleMenu">
        <KkIcon name="ic_bars_line_semibold" />
      </div>
      <div class="logo" @click="goDefaultPage">
        <img src="@/assets/imgs/layout/logo-header.png" alt="">
      </div>
      <el-drawer
        direction="ttb"
        size="100%"
        :with-header="false"
        :modal="false"
        :visible.sync="showMenu"
        :show-close="false"
      >
        <div class="menu-list">
          <div class="item k-body-md" :class="{'active': currentPath === '/manage/affiliate-cid'}" @click="goPage('/manage/affiliate-cid')">{{ $t('common.nav.manage.affiliateCid') }}</div>
          <div class="item k-body-md" :class="{'active': currentPath === '/manage/member-reward'}" @click="goPage('/manage/member-reward')">{{ $t('memberReward.memberRewards') }}</div>
          <div class="item k-body-md" :class="{'active': currentPath === '/manage/event'}" @click="goPage('/manage/event')">{{ $t('common.nav.manage.event') }}</div>
          <div class="item k-body-md" :class="{'active': currentPath === '/manage/notification'}" @click="goPage('/manage/notification')">{{ $t('common.nav.manage.notification') }}</div>
          <div class="item k-body-md" :class="{'active': currentPath === '/manage/tool'}" @click="goPage('/manage/tool')">{{ $t('common.nav.manage.managementTool') }}</div>
          <el-collapse>
            <el-collapse-item :title="currentLanguage">
              <div v-for="item of navLangList"
                :key="item.value"
                class="item k-body-md"
                @click="changeNavLanguage(item.value, 'manage'), showMenu = false"
              >{{ item.label }}</div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse>
            <el-collapse-item :title="manageAccountEmail">
              <div class="item k-body-md" @click="handleCommand('1')" v-if="isKKpartners == 1">{{ $t('common.nav.manage.switchToAffiliatePortal') }}</div>
              <div class="item k-body-md" @click="handleCommand('2')">{{ $t('common.nav.logout') }}</div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-drawer>
    </div>
  </div>

</template>

<script>
import { KkIcon, KkBadge, KkIconWithBadge } from '@kkday/web-design-system'
import NavLanguageDropdownMixin from '@/mixins/nav-language-dropdown-mixin'

export default {
  mixins: [ NavLanguageDropdownMixin ],
  components: {
    KkIcon, KkBadge, KkIconWithBadge
  },
  computed: {
    currentPath() {
      return this.$route.path
    },
    manageAccountEmail() {
      return localStorage.getItem('manageAccountEmail')
    },
    isKKpartners() {
      return localStorage.getItem('isKKpartners')
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    goDefaultPage() {
      this.$router.push('/manage/affiliate-cid')
    },
    async handleCommand(e) {
      if (e === '1') {
        if (this.isKKpartners == 1) {
          // 从管理端切换到联盟端时，实时检测登录的管理员是否有联盟端账户，「有」时可切换，「没有」时不可切换
          await this.$store.dispatch('getAccountInfo')
          if (this.$store.state.account) {
            localStorage.setItem('extraChannel', 'KKPARTNERS')
            this.$router.push('/affiliate/dashboard')
          }
        }
      }
      if (e === '2') {
        console.log('authToken has been removed! here is manage')
        localStorage.removeItem('authToken')
        this.$store.state.memberReward.prodSponsorInfo = null
        this.$store.state.memberReward.fansDiscountInfo = null
        this.$router.push('/home')
      }
    },
    handleMenu() {
      this.showMenu = !this.showMenu
    },
    goPage(path) {
      this.$router.push(path)
      this.showMenu = false
    }
  }
}
</script>

<style lang="less" scoped>
.pc-header {
  width: 100%;
  height: 70px;
  position: fixed;
  left: 0%;
  top: 0%;
  z-index: 2000;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px -1px 0px 0px #EEE inset;
  .content {
    width: 1170px;
    padding-left: var(--kk-spacing-5);
    padding-right: var(--kk-spacing-5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .item {
      cursor: pointer;
      padding: var(--kk-spacing-3) 0;
      margin: 0 var(--kk-spacing-7);
      text-decoration: none;
      &:visited {
        color: var(--kk-text-icon-color-text-darker);
      }
      &:hover {
        color: var(--kk-color-background-primary-dark);
      }
    }
  }
  .navigation {
    height: 40px;
    display: flex;
    align-items: center;
    color: var(--kk-text-icon-color-text-darker);
    font-size: 14px;
    a {
      color: var(--kk-text-icon-color-text-darker);
    }
    .logo {
      margin-right: var(--kk-spacing-10);
      cursor: pointer;
      img {
        width: 177px;
        height: 35px;
      }
    }
  }
  .system-info {
    display: flex;
    align-items: center;
    .info {
      font-size: 24px;
      position: relative;
      margin-right: var(--kk-spacing-5);
      display: flex;
      cursor: pointer;
      ::v-deep .kk-badge {
        background-color: #13A3B6;
      }
      .badge {
        background: #13A3B6;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: 700;
        color: #fff;
        position: absolute;
        right: -6px;
        top: -4px;
        border: 2px solid #fff;
      }
    }
  }
  ::v-deep .el-dropdown-link {
    line-height: 40px;
    display: flex;
    white-space: nowrap;
    .el-icon-arrow-down {
      display: flex;
      align-items: center
    }
    &:hover {
      color: var(--kk-color-text-primary-medium);
    }
  }
}
.active {
  color: var(--kk-color-background-primary-dark) !important;
}
.mweb-header {
  display: none;
  width: 100%;
  padding: var(--kk-spacing-4) var(--kk-spacing-5);
  align-items: center;
  gap: var(--kk-spacing-5);
  position: fixed;
  left: 0%;
  top: 0%;
  z-index: 2000;
  background: #fff;
  .menu-btn {
    cursor: pointer;
  }
  .logo {
    margin-top: var(--kk-spacing-2);
    img {
      width: 151px;
      height: 30px;
    }
  }
}
@media (max-width: 996px) {
  .pc-header {
    display: none;
  }
  .mweb-header {
    display: flex;
    .el-drawer__wrapper {
      top: 63px;
    }
    ::v-deep .el-drawer__body {
      text-align: left;
    }
    .item {
      display: block;
      text-decoration: none;
    }
    a {
      color: var(--kk-text-icon-color-text-darker);
      &:visited {
        color: var(--kk-text-icon-color-text-darker);
      }
      &:hover {
        color: var(--kk-color-background-primary-dark);
      }
    }
    .menu-list {
      padding: var(--kk-spacing-7);
      .item {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
      }
      .active {
        color: var(--kk-color-background-primary-dark) !important;
      }
      ::v-deep .el-collapse-item__header {
        font-size: var(--kk-text-subtitle-md-font-size) !important;
        line-height: var(--kk-text-subtitle-md-line-height) !important;
        font-weight: var(--kk-text-body-md-font-weight) !important;
        font-family: "PingFang TC";
        height: 40px;
      }
      ::v-deep .is-active {
        font-weight: var(--kk-text-subtitle-md-font-weight) !important;
      }
      ::v-deep .el-collapse-item__header {
        border: none;
      }
      ::v-deep .el-collapse-item__content {
        padding-bottom: 0;
      }
    }
  }
}
</style>
